import React from 'react';

import './pagelet-divider.scss';

export const PageletDivider = () => <div className="pagelet-divider" />;
